var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBriefcase = function SvgBriefcase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.14 5.053H2.768a1.77 1.77 0 0 0-1.774 1.77v3.293h9.22V9.4a1.39 1.39 0 0 1 1.392-1.39h2.925a1.39 1.39 0 0 1 1.39 1.39v.716h9.198V6.824a1.77 1.77 0 0 0-1.775-1.771h-4.348V2.895A2.858 2.858 0 0 0 16.152.041H9.985A2.858 2.858 0 0 0 7.14 2.895v2.158Zm9.756-2.903c.198.198.31.466.31.745v2.158H8.93V2.895A1.06 1.06 0 0 1 9.985 1.84h6.166c.28 0 .547.112.745.31Zm-5.804 7.227v2.731a1.95 1.95 0 0 0 0 .265 1.976 1.976 0 0 0 3.92 0c.013-.088.02-.176.02-.265v-2.73a.498.498 0 0 0-.498-.499H11.57a.498.498 0 0 0-.478.498ZM.994 12.365v7.114a1.774 1.774 0 0 0 1.774 1.775h20.6a1.775 1.775 0 0 0 1.775-1.775v-7.114H15.91a2.854 2.854 0 0 1-5.684 0H.994Z",
    fill: "#fff"
  })));
};
export default SvgBriefcase;